import Glider from "glider-js";

(function () {
  const carousels = document.querySelectorAll(".js-carousel.glider");

  for (const carousel of carousels) {
    new Glider(carousel, {
      slidesToShow: "auto",
      dragVelocity: 1.5,
      draggable: true,
      skipTrack: true,
    });
  }
})();
